var mainpage = {
	sActive : '.active',
	sAddToPlaylistButton : 'span.drag',
	sAwardDD : "#awards_dd",
	sBlockCarousel : ".carousel_block",
	sBlockCarouselSmall : ".carousel_block.small .carousel_container",
	sBlockCarouselMid : ".carousel_block.middle .carousel_container",
	sBtnSearch : ".btn_search",
	sCarouselOpener : '.carousel_block .opener',
	sDoTruncate : ".doTruncate",
	sDoTruncate2Row : ".do-truncate-2-row",
	sDoTruncate3Row : ".do-truncate-3-row",
	sErotikaBody : "body.erotika",
	sErotikaLayer : ".adult-layer.layer-background",
	sErotikaLayerButton : ".adult-layer .layer button",
	sFullscreenLink : '#fullscreen_link',
	sFullscreenLinkImg : '#fullscreen_link img',
	sHeader : 'body > header',
	sItem : '.item',
	sMainContainer : '.main-container',
	sMenuOpener : '.menu_opener',
	sNewPlaylist : '.new_playlist',
	sNewPlaylistForm : '.new_playlist_form',
	sOpened : '.opened',
	sOwlContainer : "",
	sPlaylists : ".playlists",
	sPlaylistItem : '.playlists ul li.playlist_name',
	sPlaylistName : '.playlist_name',
	sRepositionPlaylistsItem : '.item.reposition-playlists',
	sSearchBar : '.inpt_search',
	sSearchInput : '#inpt_head_searchbox',
	sThumbInnerDesc : ".item .video_thumb h2",
	sTmbActions : '.tmbActions',
	sTopNavigation : '#topNavigation',
	sTopMenu : "#topMenu",
	sVideoThumb : ".video_thumb",
	sVideoThumbnail : ".video-thumbnail",
	sWatchLater : ".add_watch_later",
	sWatchLaterToggler : "#watchlater_toggler",
	sWatchLaterContainer : "#watchlater_videos",

	classClosed : 'closed',
	classOpened : 'opened',
	classOverflow : 'overflow',
	classActive : 'active',
	classLater : 'later',
	classLoaded : 'loaded',
	classLoggedIn : 'logged_in',
	classMenuOpened : 'menu_opened',
	classSearchboxOpened : 'opened_searchbox',

	urlUserHandler: '/userhandler',
    urlVideoHandler: '/videohandler',

    countPlaylists : 0,
    isChangedThumbnails : 0, 
    desktopWidth : 1000,
    mobileWidth : 480,
    mobletWidth : 640,
    tabletWidth : 768,

    playlists : [],

    last_known_scroll_position : 0,
	ticking : false,
	linkTop : 200,
	fsAdHeight : 200,
	fsAdElement : null,

    cookieSubscribeOpened : "subscribe_opened2",

	oOwlConfig : {
		itemElement: 'div',
		loop: true,
	    margin: 15,
	    responsiveClass: true,
	    nav: true,
	    navText: [
	    	'<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" xml:space="preserve"><path d="M20.511,27.679c-0.864-0.843-9.314-9.716-9.314-9.716c-0.461-0.45-0.692-1.04-0.692-1.63c0-0.59,0.23-1.18,0.692-1.63c0,0,8.45-8.872,9.314-9.716c0.865-0.843,2.42-0.901,3.343,0c0.922,0.9,0.996,2.156-0.001,3.26l-7.752,8.086l7.752,8.085c0.996,1.104,0.923,2.36,0.001,3.26C22.931,28.58,21.376,28.522,20.511,27.679z"/></svg>',
	    	'<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" xml:space="preserve"><path d="M14.568,4.988c0.864,0.843,9.314,9.716,9.314,9.716c0.461,0.45,0.692,1.04,0.692,1.63c0,0.59-0.23,1.18-0.692,1.63c0,0-8.45,8.872-9.314,9.716c-0.865,0.843-2.42,0.901-3.343,0c-0.922-0.899-0.996-2.156,0.001-3.26l7.752-8.086l-7.752-8.085c-0.996-1.104-0.923-2.36-0.001-3.26C12.148,4.087,13.703,4.144,14.568,4.988z"/></svg>'
    	],
	    lazyLoad: false,
	    slideBy: 2,
	    responsive: {
	        0: {
	            items: 1,
	            nav: true
	        },
	        640: {
	        	items: 2,
	        	nav: true
	        },
	        768: {
	            items: 2,
	            nav: true
	        },
	        1000: {
	            items: 3,
	            nav: true,
	            loop: true
	        }
	    }
	},
	oOwlSmallConfig : {
		slideBy: 5,
		responsive : {
	        0: {
	            items: 1,
	            nav: true
	        },
	        640: {
	        	items: 2,
	        	nav: true
	        },
	        768: {
	            items: 3,
	            nav: true
	        },
	        1000: {
	            items: 5,
	            nav: true,
	            loop: true
	        }
	    }
	},

	eAddNewPlaylist : function(e) {
		var mom = e.data.mom;

		mom.preventEvent(e);

		var title = $(e.target).find(mom.sNewPlaylist).val();
		var videoUrlTitle = $(e.target).find(mom.sNewPlaylist).attr('data-title');

		IV.playlist.createPlaylist(title,videoUrlTitle);
	},

	eBodyClick : function(e) {
		var mom = e.data.mom;

		$(mom.sMainContainer + " " + mom.sActive).removeClass(mom.classActive);
	},

	// eCloseMobileMenu : function(e) {
	// 	var mom = e.data.mom;

	// 	if ($(e.target)[0].nodeName == 'NAV') {
	// 		mom.preventEvent(e);
	// 		$(mom.sTopMenu).removeClass(mom.classOpened);
	// 		$('html').removeClass(mom.classMenuOpened);
	// 		$('body').removeClass(mom.classMenuOpened);
	// 	}
	// },

	eErotikaLayerButtonClick : function(e) {
		var mom = e.data.mom;

		if ($(this).attr('data-value') == 'yes') {
			setCookie ('indavideoErotika', 1 , 1, '/', 'indavideo.hu', false);
			$(mom.sErotikaLayer).hide();

			if ($(mom.sErotikaBody).length != 0) {
				var newImage = '';

				$("#indafoto-erotika-box .item_inner").removeClass('adult_overlay');

				$(mom.sVideoThumbnail).each(function(index, element) {
					newImage = $(element).attr('data-srcoriginal');

					$(element).attr('data-src', newImage);

					if ($(element).attr('src') != '')
						$(element).attr('src', newImage);
				});
			}
		}
		else
			window.location.href = 'http://indavideo.hu';
	},

	ePalyazatMenuToggle : function(e) {
		var mom = e.data.mom;

		if ($(e.target)[0].nodeName != 'A') {
			mom.preventEvent(e);

			$(mom.sAwardDD).toggleClass(mom.classOpened);
			$(mom.sAwardDD).find("ul").first().toggleClass(mom.classOpened);
		}
	},

	ePlaylistClick : function(e) {
		var mom = e.data.mom;
		
		mom.preventEvent(e);

		var playlistId = $(e.target).attr('data-id');
		var videoUrlTitle = $(e.target).closest(mom.sTmbActions).find(mom.sAddToPlaylistButton + " input").val();

		videoBoxHandler.addToPlaylist(playlistId,videoUrlTitle);

		var closestItem = $(e.target).closest(mom.sItem);
		$(closestItem).removeClass(mom.classOpened);
	},

	ePreventOnly : function(e) {
		e.data.mom.preventEvent(e);
	},

	eSetWatchLater : function(e) {
		var mom = e.data.mom;

		mom.preventEvent(e);

        var url_title = $(e.target).attr("data-title");
        var addremove = 1;

        if ($(e.target).hasClass(mom.classLater))
            addremove = 0;

        mom.watchlater(url_title, addremove, { target: e.target });
	},

	eShowPlaylistsToAdd : function(e) {
		var mom = e.data.mom;

		mom.preventEvent(e);

		var closestItem = $(e.target).closest(mom.sItem);

		if (!$(closestItem).hasClass(mom.classOpened))
			$(mom.sOpened).removeClass(mom.classOpened);
		
		if (!$(closestItem).hasClass(mom.classOpened)) {
			mom.resetPlaylists($(closestItem).find(mom.sPlaylists).first());
		}

		$(closestItem).toggleClass(mom.classOpened);
	},

	eToggleCarouselOpen : function(e) {
		var mom = e.data.mom;

		$(this).closest(mom.sBlockCarousel).toggleClass(mom.classClosed);

		if ($(this).closest(mom.sBlockCarousel).hasClass(mom.classClosed))
			setCookie (mom.cookieSubscribeOpened, 0 , 1, '/', 'indavideo.hu', false);
		else
			setCookie (mom.cookieSubscribeOpened, 1 , 1, '/', 'indavideo.hu', false);
	},

	eToggleMobileMenu : function(e) {
		var mom = e.data.mom;

		$(mom.sSearchBar).removeClass(mom.classOpened);
		$(mom.sHeader).removeClass(mom.classSearchboxOpened);

		$(mom.sMenuOpener).toggleClass(mom.classOpened);
		$(mom.sTopMenu).toggleClass(mom.classOpened);
		$('html').toggleClass(mom.classMenuOpened);
		$('body').toggleClass(mom.classMenuOpened);
	},

	eToggleSearchBar : function(e) {
		var mom = e.data.mom;

		if (mom.isWindowSmallerOrEqualThan(mom.mobletWidth) || ($(mom.sTopNavigation).hasClass(mom.classLoggedIn) && mom.isWindowSmallerOrEqualThan(mom.tabletWidth))) {
			mom.preventEvent(e);

			$(mom.sMenuOpener).toggleClass(mom.classOpened);
			$(mom.sTopMenu).removeClass(mom.classOpened);
			$('html').removeClass(mom.classMenuOpened);
			$('body').removeClass(mom.classMenuOpened);

			$(mom.sSearchBar).toggleClass(mom.classOpened);
			$(mom.sHeader).toggleClass(mom.classSearchboxOpened);

			if ($(mom.sSearchBar).hasClass(mom.classOpened))
				$(mom.sSearchInput).focus();
		}
	},

	eToggleWatchlater : function(e) {
		var mom = e.data.mom;

		if (GetCookie('watchlater_opened') == 1) {
			$(mom.sWatchLaterToggler).closest('.back').removeClass(mom.classOpened);
			$(mom.sWatchLaterContainer).removeClass(mom.classOpened);
			$(mom.sWatchLaterContainer).removeClass(mom.classOverflow);
			deleteCookie('watchlater_opened', '/', 'indavideo.hu');
		}
		else {
			setCookie ('watchlater_opened', 1 , 1, '/', 'indavideo.hu', false);
			$(mom.sWatchLaterToggler).closest('.back').addClass(mom.classOpened);
			$(mom.sWatchLaterContainer).addClass(mom.classOpened);
			setTimeout(function() {
				$(mom.sWatchLaterContainer).addClass(mom.classOverflow);
			}, 200);
		}
	},

	eWindowResize : function(e) {
		var mom = e.data.mom;

		$(mom.sSearchBar).removeClass(mom.classOpened);
		$(mom.sHeader).removeClass(mom.classSearchboxOpened);

		mom.toggleResizedThumbnails();
		mom.initFullscreenAd();
		mom.recalculateRepositionedPlaylistsHeight();

		if ($(mom.sFullscreenLink).length > 0)
			mom.linkTop = $(mom.sFullscreenLink).offset().top;
	},

	eWindowScroll : function(e) {
		if ($(this).scrollTop() >= mainpage.linkTop ) {
			mainpage.fsAdElement.addClass('fixed-image');
		}
		else {
			mainpage.fsAdElement.removeClass('fixed-image');
		}
	},

	recalculateRepositionedPlaylistsHeight : function() {
		var mom = this;
		var itemHeight,
			applyableHeight;

		$(mom.sRepositionPlaylistsItem).each(function(index,item) {
			itemHeight = $(item).innerHeight();
			applyableHeight = itemHeight - 15;

			$(item).find(mom.sPlaylists).css('height', applyableHeight);
			itemHeight = applyableHeight = 0;
		});
	},

	toggleResizedThumbnails : function() {
		var mom = this;

		if (mom.isChangedThumbnails && !mom.isWindowSmallerOrEqualThan(mom.desktopWidth)) {
			mom.isChangedThumbnails = 0;
			mom.changeThumbnailSizes();
		}
		else if (!mom.isChangedThumbnails && mom.isWindowSmallerOrEqualThan(mom.desktopWidth)) {
			mom.isChangedThumbnails = 1;
			mom.changeThumbnailSizes(true);
		}
	},

	changeThumbnailSizes : function(changeToMobileSize) {
		var mom = this,
			originalThumbnailUrl = '',
			newThumbnailUrl = '',
			urlParts = [],
			filename = '',
			lastUrlPartKey = 0,
			elementWidth = 0,
			newSize = 3;

		if (changeToMobileSize) {
			$(mom.sVideoThumb).each(function(index, element) {
				originalThumbnailUrl = mom.getBackgroundImageUrl(element);

				$(element).attr('data-originalthumbnail', (originalThumbnailUrl != 'none' ? originalThumbnailUrl : ''));

				if ($(element).attr('data-mobilethumbnail') != undefined && $(element).attr('data-mobilethumbnail') != '' && $(element).attr('data-mobilethumbnail') != 'none') {
					mom.setBackgroundImage(element,$(element).attr('data-mobilethumbnail'));
				}
				else if (originalThumbnailUrl != 'none') {
					urlParts = mom.getImageUrlParts(originalThumbnailUrl);
					lastUrlPartKey = urlParts.length - 1;
					filename = urlParts[lastUrlPartKey];

					if (mom.isAdultPlaceholder(originalThumbnailUrl)) {
						elementWidth = $(element).width();
						newSize = mom.getThumbnailSize(elementWidth,true);
						urlParts[lastUrlPartKey] = filename.replace(/iv\_18\_\d\d\dx\d\d\d/,'iv_18_' + newSize);
					}
					else if (mom.isValidThumbnailUrl(originalThumbnailUrl)) {
						elementWidth = $(element).width();
						newSize = mom.getThumbnailSize(elementWidth);
						urlParts[lastUrlPartKey] = filename.replace(/\d\-/, newSize + '-');
					}

					newThumbnailUrl = urlParts.join('/');
					$(element).attr('data-mobilethumbnail', newThumbnailUrl);

					mom.setBackgroundImage(element,newThumbnailUrl);
				}
			});
		}
		else {
			$(mom.sVideoThumb).each(function(index, element) {
				originalThumbnailUrl = $(element).attr('data-originalthumbnail');
				
				if (originalThumbnailUrl != undefined && originalThumbnailUrl != 'none')
					mom.setBackgroundImage(element,originalThumbnailUrl);
			});
		}
	},

	getBackgroundImageUrl : function(element) {
		var backgroundImage = $(element).css('backgroundImage');
		var backgroundImageUrl = backgroundImage.replace('url("','').replace('")','');

		return backgroundImageUrl == 'none' ? '' : backgroundImage;
	},

	getImageUrlParts : function(url) {
		return url.split('/');
	},

	getThumbnailSize : function(elementWidth, adultPlaceholder) {
		var returnSize = 3;

		if (adultPlaceholder)
			returnSize = '330x248';

		switch (true) {
			case elementWidth > 640: 
				if (adultPlaceholder)
					returnSize = '720x540';
				else
					returnSize = 4;
				break;
			case elementWidth <= 640 && elementWidth > 310:
				if (adultPlaceholder)
					returnSize = '640x480';
				else
					returnSize = 1;
				break;
			case elementWidth <= 310:
				if (adultPlaceholder)
					returnSize = '330x248';
				else
					returnSize = 3;
				break;
			default: break;
		}

		return returnSize;
	},

	isAdultPlaceholder : function(url) {
		return /\/18\_placeholders\//g.test(url);
	},

	isValidThumbnailUrl : function(url) {
		var mom = this;
		var isValid = false;

		if (/pics\.indavideo\.hu/g.test(url))
			isValid = true;

		if (/\d\-\d\.jpg$/g.test(url))
			isValid = true;

		return isValid;
	},

	setBackgroundImage : function(element,url) {
		var image = 'url("' + url + '")';

		if (/^url\(/.test(url))
			image = url;

		$(element).css('backgroundImage', image);
	},

	isWindowSmallerOrEqualThan : function(size) {
		var mom = this;

		return document.body.clientWidth <= size;
	},
 
	init : function() {
		var self = this;

		if (!this.isWebkit())
			$(this.sDoTruncate).dotdotdot({
				wrap: "word",
				watch: "window"
			});

		$(this.sVideoThumbnail).unveil(200, function() {
			$(this).load(function() {
				$(this).closest(self.sVideoThumb).addClass(self.classLoaded);
			});
		});

		this.initSmallCarousel();
		this.initMiddleCarousel();

		this.setEventHandlers();

		this.countPlaylists = $(this.sPlaylists).first().find('.playlist_name').length;

		this.initMobileMenu();

		this.initPLaylists();

		this.initFullscreenAd();

		var fakeEventObject = {data: {mom:this}};
		this.eWindowResize(fakeEventObject);
		if ($(this.sFullscreenLink).length > 0) {
			this.linkTop = $(this.sFullscreenLink).offset().top;
			this.fsAdHeight = $(this.sFullscreenLink).height();
			this.eWindowScroll(fakeEventObject);
		}
		// this.eToggleMobileMenu(fakeEventObject);
	},

	isWebkit : function() {
		var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    	var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

    	return isChrome || isSafari;
	},

	initMiddleCarousel : function() {
		var mom = this,
			config = mom.oOwlConfig;
		
		$(mom.sBlockCarouselMid).owlCarousel(config);
	},

	initMobileMenu : function() {
		var mom = this;
		
		$(document).on('click',mom.sMenuOpener,{mom:mom},mom.eToggleMobileMenu);
		// $(document).on('click',mom.sTopMenu,{mom:mom},mom.eCloseMobileMenu);
	},

	initPLaylists : function() {
		var mom = this,
			playlistData = {};
		
		$(mom.sPlaylists).first().find(mom.sPlaylistName).each(function(index, el) {
			playlistData = {
				id : $(el).attr('data-id'),
				name : $(el).text()
			};

			mom.playlists.push(playlistData);
			playlistData = {};
		});
	},

	initSmallCarousel : function() {
		var config = $.extend(true,{},this.oOwlConfig,this.oOwlSmallConfig);

		$(this.sBlockCarouselSmall).owlCarousel(config);
	},

	initFullscreenAd : function() {
		var mom = this;

		switch(true) {
			case mom.isWindowSmallerOrEqualThan(mom.mobileWidth): 
				mom.setFullscreenTo('mobile');
				break;
			
			case mom.isWindowSmallerOrEqualThan(mom.mobletWidth): 
			case mom.isWindowSmallerOrEqualThan(mom.tabletWidth): 
				mom.setFullscreenTo('moblet');
				break;

			case mom.isWindowSmallerOrEqualThan(mom.desktopWidth): 
				mom.setFullscreenTo('tablet');
				break;

			case mom.isWindowSmallerOrEqualThan(1400): 
				mom.setFullscreenTo('default');
				break;

			default: 
				mom.setFullscreenTo('original');
				break;
		}
	},

	setFullscreenTo : function(deviceType) {
		var mom = this;
		
		if (deviceType == 'original') {
			// $(mom.sFullscreenLinkImg).hide().attr('src','');
		}
		else {
			var fullscreenImage = $(mom.sFullscreenLinkImg).attr('data-' + deviceType);
			if (fullscreenImage && $(mom.sFullscreenLinkImg).attr('src') != fullscreenImage)
				$(mom.sFullscreenLinkImg).attr('src',fullscreenImage).show();
		}
	},

	preventEvent : function(e) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();
	},

	resetPlaylists : function(targetElement) {
		var mom = this;

		if (typeof(targetElement) != 'object' && !(targetElement instanceof jQuery)) {
			console.log('there is no jquery target element');
			return false;
		}

		var firstLiElement = $(targetElement).find('li').first(),
			playlistsHTML = '';

		$.each(mom.playlists, function(index, val) {
			playlistsHTML += '<li class="' + mom.sPlaylistName.replace('.','') + '" data-id="' + val.id + '">' + val.name + '</li>';
		});

		if (mom.playlists.length > 0 && playlistsHTML != '') {
			$(targetElement).find(mom.sPlaylistName).remove();
			$(firstLiElement).after(playlistsHTML);
		}
	},

	setEventHandlers : function() {
		var mom = this;

		$(document).on('click','body',{mom:mom},mom.eBodyClick);
		$(document).on('click',mom.sAwardDD,{mom:mom},mom.ePalyazatMenuToggle);
		$(document).on('click',mom.sAddToPlaylistButton,{mom:mom},mom.eShowPlaylistsToAdd);
		$(document).on("click",mom.sPlaylistItem,{mom:mom},mom.ePlaylistClick);
		$(document).on("click",mom.sWatchLater,{mom:mom},mom.eSetWatchLater);
		$(document).on('click',mom.sBtnSearch,{mom:mom},mom.eToggleSearchBar);
		$(document).on('submit',mom.sNewPlaylistForm,{mom:mom},mom.eAddNewPlaylist);
		$(document).on('click',mom.sNewPlaylistForm,{mom:mom},mom.ePreventOnly);
		$(document).on('click',mom.sNewPlaylist,{mom:mom},mom.ePreventOnly);
		$(document).on('click',mom.sErotikaLayerButton,{mom:mom},mom.eErotikaLayerButtonClick);
		$(document).on('click',mom.sWatchLaterToggler,{mom:mom},mom.eToggleWatchlater);
		$(document).on('click',mom.sCarouselOpener,{mom:mom},mom.eToggleCarouselOpen);
		$(window).on('resize',{mom:mom},mom.eWindowResize);
	},

	closePlaylistMenu : function() {
		var mom = this;

		$(mom.sOpened).removeClass(mom.classOpened);

		$(mom.sItem).removeClass(mom.classOpened);
	},

	watchlater: function(url_title, addremove, D) {
		var mom = this;

		if ((!url_title || !addremove) && addremove != 0)
			return false;

        var target = (D.target instanceof jQuery) ? D.target : $(D.target);
        target.addClass('pulsing');

		// _gaq.push(['t2._trackEvent', 'Subscribe', 'SubsBarWatchLater', mom.page]);

		$.ajax(
		{
			url: mom.urlVideoHandler,
			type: "POST",
			dataType: 'json',
			data:
			{
				op: 'watchlater',
				action: 'videoHandler',
				addOrRemove: addremove,
				url_title: url_title
			},
			success: function(res)
			{
                target.removeClass('pulsing').removeAttr('title').toggleClass(mom.classLater);
        //         if (!D.removeLayer) {
    				// target.toggleClass(mom.classLater);
        //             if (target.hasClass(mom.sWatchLaterBtn.replace(/[\.\#]{1}/g, ""))) {
        //                 mom.addOpacityLayerToElement(target.closest(".item"),mom.constWATCHLATER);
        //             }
        //         }
        //         else {
        //             var item = (target.hasClass('item')) ? target : target.closest('.item');

        //             IVUser.removeOpacityLayer(item);
        //         }
			}
		});
	}
};

$(document).ready(function() {
	if ($(mainpage.sFullscreenLink).length > 0) {
		mainpage.fsAdElement = $(mainpage.sFullscreenLink);
		mainpage.linkTop = mainpage.fsAdElement.offset().top;
		mainpage.fsAdHeight = mainpage.fsAdElement.height();
		$(window).scroll(mainpage.eWindowScroll);
	}
});